import loadable from 'components/dynamic-import';

export const ManualAuthentication = loadable(() => import('./ManualAuthentication'));
